import React from 'react';
import { EuiEmptyPrompt } from '@elastic/eui';

const PageNotFound = () => {
    return <EuiEmptyPrompt iconType='faceSad' style={{ marginTop: '40vh' }} title={<h2>404 Not Found</h2>} />;
};
export default PageNotFound;
